// Exclusion.js
import React, { useState, useEffect } from "react";
import { Box, Button, Dialog, DialogTitle, DialogContent, MenuItem, Select } from "@mui/material";
import PillInput from "./InputFieldWithPills";
import { TYPE_LIST, MONTH_LIST } from "../data.js";
import axios from "axios";
import { GlobalState } from "context/GlobalContext";

function ExclusionModal({ open, onClose }) {
	const [data, setData] = useState(null);
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

	// Reset state when modal is closed
	useEffect(() => {
		if (!open) {
			setData(null);
		}
	}, [open]);

	const handleTypeChange = (event) => {
		const value = event.target.value;
		if (value === "ORDER_ID") {
			setData({ type: "ORDER_ID", values: [] });
		} else if (value === "VOUCHER") {
			setData({ type: "VOUCHER", month: "", values: [] });
		} else {
			setData(null);
		}
	};

	const handleMonthChange = (event) => {
		setData((prev) => ({ ...prev, month: event.target.value }));
	};

	const handlePillsChange = (pills) => {
		setData((prev) => ({ ...prev, values: pills }));
	};

	const handleClear = () => {
		if (data?.type === "ORDER_ID") {
			setData({ type: "ORDER_ID", values: [] });
		} else if (data?.type === "VOUCHER") {
			setData({ type: "VOUCHER", month: "", values: [] });
		}
	};

	const handleSave = () => {
		setLoadingOpen(true);
		axios
			.post("/api/exclusion/save-exclusions", data)
			.then((res) => {
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Data saved successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			})
			.catch((err) => {
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Failed to save data",
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			})
			.finally(() => {
				setLoadingOpen(false);
			});
		onClose(); // closing will also reset
	};

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>Exclusion Setup</DialogTitle>
			<DialogContent>
				<Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
					{/* Type Dropdown */}
					<Select value={data?.type || ""} onChange={handleTypeChange} displayEmpty fullWidth>
						<MenuItem value="" disabled>
							Select Type
						</MenuItem>
						{TYPE_LIST.map((item) => (
							<MenuItem key={item.value} value={item.value}>
								{item.name}
							</MenuItem>
						))}
					</Select>

					{/* Month dropdown only when Voucher is selected */}
					{data?.type === "VOUCHER" && (
						<Select value={data?.month || ""} onChange={handleMonthChange} displayEmpty fullWidth>
							<MenuItem value="" disabled>
								Select Month
							</MenuItem>
							{MONTH_LIST.map((month) => (
								<MenuItem key={month.value} value={month.value}>
									{month.name}
								</MenuItem>
							))}
						</Select>
					)}

					{/* Pill Input */}
					{data?.type && <PillInput values={data.values} onChange={handlePillsChange} />}

					{/* Buttons */}
					{data?.type && (
						<Box sx={{ display: "flex", gap: 2, mt: 2 }}>
							<Button variant="outlined" color="secondary" onClick={handleClear}>
								Clear
							</Button>
							<Button variant="contained" color="primary" onClick={handleSave}>
								Save
							</Button>
						</Box>
					)}
				</Box>
			</DialogContent>
		</Dialog>
	);
}

export default ExclusionModal;
